__turbopack_context__.v({
  "className": "poppins_112cc813-module__9zylSq__className",
});
